import http from '@/lib/http.js';

var store = {
	namespaced: true,
	state: {},
	getters: {},
	mutations: {},
	actions: {
		init: function(store) {},
		async trackEvent(store, name) {
			let form = {};
			if (typeof name === 'object') {
				form.name = name.name;
				form.data = name.data;
			} else {
				form.name = name;
			}
			return http.request('post', '/event/', form);
		}
	}
};

export default store;
